import { Link } from "react-router-dom";
import EllipsisText from "components/EllipsisText";
import formatPhone from "helpers/phone_formatter";
import { EditOutlined } from "@ant-design/icons";

const getColumns = (clients_index_columns) => {
  const renderLink = (id, name, content) => {
    if ([clients_index_columns?.[0]].includes(name)) {
      return (
        <Link to={`/clients/${id}`}>
          {content} <EditOutlined />
        </Link>
      );
    }
    return content;
  };

  return [
    {
      title: "Telefon",
      dataIndex: "phone",
      sortable: true,
      searchable: true,
      search_method: "matches",
      search_type: "number",
      render: (_, { id, phone }) => renderLink(id, "phone", formatPhone(phone)),
    },
    {
      title: "Adres",
      dataIndex: "street",
      sortable: false,
      searchable: true,
      search_method: "matches",
      render: (_, { id, street, building_number, apartment_number }) =>
        renderLink(
          id,
          "street",
          <EllipsisText
            text={`${street} ${building_number}${
              apartment_number ? `/${apartment_number}` : ""
            }`}
            limit={40}
          />
        ),
    },
    {
      title: "Imię",
      dataIndex: "first_name",
      sortable: true,
      searchable: true,
      search_method: "matches",
      render: (_, { id, first_name }) =>
        renderLink(
          id,
          "first_name",
          <EllipsisText text={first_name} limit={20} />
        ),
    },
    {
      title: "Nazwisko",
      dataIndex: "last_name",
      sortable: true,
      searchable: true,
      search_method: "matches",
      render: (_, { id, last_name }) =>
        renderLink(
          id,
          "last_name",
          <EllipsisText text={last_name} limit={20} />
        ),
    },
    {
      title: "Miasto",
      dataIndex: "city",
      sortable: true,
      searchable: true,
      search_method: "matches",
      render: (_, { id, city }) =>
        renderLink(id, "city", <EllipsisText text={city} limit={20} />),
    },
    {
      title: "Kod pocztowy",
      dataIndex: "post_code",
      sortable: true,
      searchable: true,
      search_method: "matches",
      render: (_, { id, post_code }) =>
        renderLink(
          id,
          "post_code",
          <EllipsisText text={post_code} limit={7} />
        ),
    },
    {
      title: "Nazwa firmy",
      dataIndex: "company_name",
      sortable: false,
      searchable: true,
      search_method: "matches",
      render: (_, { id, company_name, is_company }) =>
        is_company ? renderLink(id, "company_name", company_name || "-") : "-",
    },
    {
      title: "Nip",
      dataIndex: "nip",
      sortable: false,
      searchable: true,
      search_method: "matches",
      render: (_, { id, nip, is_company }) =>
        is_company ? renderLink(id, "nip", nip || "-") : "-",
    },
    {
      title: "Podmiot",
      dataIndex: "is_company",
      sortable: false,
      searchable: true,
      search_method: "in",
      search_component: "select",
      options: [
        { label: "Firma", value: 1 },
        { label: "Osoba fizyczna", value: 0 },
      ],
      render: (_, { is_company }) => (is_company ? "Firma" : "Osoba fizyczna"),
    },
  ];
};

export default getColumns;
